document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initHero();
  initResenas();
  initProducto();
  initStickyBuy();
  initFaq();
});

function initFaq() {
  var wraps = document.querySelectorAll('[data-cda-faq]');
  wraps.forEach(function (wrap) {
    var items = wrap.querySelectorAll('.cda-faq-item');
    items.forEach(function (item) {
      var toggle = item.querySelector('[data-cda-faq-toggle]');
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        item.classList.toggle('is-open');
      });
    });
  });
}

function initReveal() {
  var els = document.querySelectorAll('.cda-reveal, .cda-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('cda-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('cda-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initHero() {
  var hero = document.querySelector('[data-cda-hero]');
  if (!hero) return;
  var slides = hero.querySelectorAll('.cda-hero-slide');
  var dots = hero.querySelectorAll('.cda-hero-dot');
  var ctas = hero.querySelectorAll('.cda-hero-cta-slide');
  if (slides.length <= 1) return;
  var current = 0;
  var intervalMs = parseInt(hero.getAttribute('data-interval'), 10) || 6000;
  var timer = null;

  function show(index) {
    slides.forEach(function (s, i) { s.classList.toggle('is-active', i === index); });
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    ctas.forEach(function (c, i) { c.classList.toggle('is-active', i === index); });
    current = index;
  }

  function next() { show((current + 1) % slides.length); }

  function start() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    stop();
    timer = setInterval(next, intervalMs);
  }
  function stop() { if (timer) clearInterval(timer); }

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { show(i); start(); });
  });

  hero.addEventListener('mouseenter', stop);
  hero.addEventListener('mouseleave', start);

  show(0);
  start();
}

function initResenas() {
  var wrap = document.querySelector('[data-cda-resenas]');
  if (!wrap) return;
  var track = wrap.querySelector('.cda-resenas-track');
  if (!track) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  // Duplica el contenido para loop infinito de marquesina
  track.innerHTML += track.innerHTML;
}

function initProducto() {
  var section = document.querySelector('[data-cda-producto]');
  if (!section) return;

  // Galería: clic en miniatura cambia la imagen principal
  var mainImg = section.querySelector('[data-cda-prod-imagen-principal]');
  var minis = section.querySelectorAll('[data-cda-prod-mini]');
  var contador = section.querySelector('[data-cda-prod-contador]');
  minis.forEach(function (mini, idx) {
    mini.addEventListener('click', function () {
      if (mainImg) mainImg.src = mini.getAttribute('data-full');
      minis.forEach(function (m) { m.classList.remove('is-active'); });
      mini.classList.add('is-active');
      if (contador) contador.textContent = (idx + 1) + ' / ' + minis.length;
    });
  });

  // Deslizar con el dedo sobre la foto principal para cambiar de imagen
  var galeria = section.querySelector('.cda-prod-galeria-principal');
  if (galeria && minis.length > 1) {
    var inicioX = null;
    galeria.addEventListener('touchstart', function (e) { inicioX = e.touches[0].clientX; }, { passive: true });
    galeria.addEventListener('touchend', function (e) {
      if (inicioX === null) return;
      var dx = e.changedTouches[0].clientX - inicioX;
      inicioX = null;
      if (Math.abs(dx) < 40) return;
      var actual = 0;
      minis.forEach(function (m, i) { if (m.classList.contains('is-active')) actual = i; });
      var siguiente = actual + (dx < 0 ? 1 : -1);
      if (siguiente >= 0 && siguiente < minis.length) minis[siguiente].click();
    }, { passive: true });
  }

  // Variantes: si hay selects de opciones, localizar la variante y actualizar precio/id/estado
  var selects = section.querySelectorAll('[data-cda-prod-opcion]');
  if (!selects.length) return;

  var variantesScript = section.querySelector('[data-cda-prod-variantes]');
  if (!variantesScript) return;
  var variantes;
  try { variantes = JSON.parse(variantesScript.textContent); } catch (e) { return; }

  var idInput = section.querySelector('[data-cda-prod-id-input]');
  var precioEl = section.querySelector('[data-cda-prod-precio]');
  var boton = section.querySelector('[data-cda-prod-boton]');
  var botonTexto = section.querySelector('[data-cda-prod-boton-texto]');
  var stockEl = section.querySelector('[data-cda-prod-stock]');

  function moneda(centavos) {
    return '$' + (centavos / 100).toFixed(2);
  }

  function actualizar() {
    var valoresSeleccionados = [];
    selects.forEach(function (s) { valoresSeleccionados.push(s.value); });

    var match = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === valoresSeleccionados[i]; });
    });
    if (!match) return;

    idInput.value = match.id;
    if (precioEl) precioEl.textContent = moneda(match.price);
    var stickyPrecio = document.querySelector('[data-cda-sticky-precio]');
    if (stickyPrecio) stickyPrecio.textContent = moneda(match.price);
    if (match.available) {
      boton.removeAttribute('disabled');
      if (botonTexto) botonTexto.textContent = boton.getAttribute('data-texto-disponible') || botonTexto.textContent;
    } else {
      boton.setAttribute('disabled', 'disabled');
      if (botonTexto) botonTexto.textContent = 'Agotado';
    }

    // Sin mensaje de "Solo quedan X": el inventario de dropshipping no es stock real.
    if (stockEl) stockEl.style.display = 'none';
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
}

function initStickyBuy() {
  var bar = document.querySelector('[data-cda-sticky]');
  var section = document.querySelector('[data-cda-producto]');
  if (!bar || !section) return;
  var mainBtn = section.querySelector('[data-cda-prod-boton]');
  var form = section.querySelector('#cda-prod-form');
  var stickyBtn = bar.querySelector('[data-cda-sticky-boton]');
  if (!mainBtn || !form || !stickyBtn) return;
  var hayOpciones = !!section.querySelector('[data-cda-prod-opcion]');
  if (hayOpciones) stickyBtn.textContent = 'Elegir opciones';

  stickyBtn.addEventListener('click', function () {
    if (hayOpciones) {
      form.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else if (!mainBtn.disabled) {
      mainBtn.click();
    }
  });

  if (!('IntersectionObserver' in window)) return;
  new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    });
  }, { threshold: 0.6 }).observe(mainBtn);
}
